export default {
  label: {
    button: {
      clearButton: 'Limpiar todo',
    },
  },
};
